import React, { useState, useEffect, useCallback } from "react"
import { Modal, Button, CardBody } from "reactstrap"
import api from "services/api"
import PastDueAppointmentForm from "components/Forms/PastDueAppointmentForm"

const emptyBody = {
  customer: "", 
  project: "", 
  date: "", 
  hours: "000:00", 
  description: "" 
}

export default function CreatePastDueAppointment(props) {
  const [loading, setLoading] = useState(false)
  const [customers, setCustomers] = useState([])
  const [projects, setProjects] = useState([])
  const [appointmentBody, setAppointmentBody] = useState(emptyBody)

  const fetchData = useCallback(async () => {
    try {
      const custRes = await api.get("customer/allWithProjects")
      
      const customersWithSLA = custRes.data.filter(customer => {
        return (customer.projects || []).some(p => 
          p.projectType === "C" || p.type === "C"
        )
      })

      setCustomers(customersWithSLA)
    } catch (e) { 
      console.error("Erro ao buscar clientes") 
    }
  }, [])

  useEffect(() => { 
    if (props.isOpen) {
      fetchData();
    }
  }, [props.isOpen, fetchData]);

  useEffect(() => { 
    if (props.isOpen && customers.length > 0) {
      if (props.editData && appointmentBody._id !== props.editData._id) {
        const customerId = props.editData.customer?._id || props.editData.customer;
        const projectId = props.editData.project?._id || props.editData.project;

        const selectedCustomer = customers.find(c => c._id === customerId);
        
        if (selectedCustomer) {
          const filtered = (selectedCustomer.projects || []).filter(p => 
            p.projectType === "C" || p.type === "C"
          );
          
          setProjects(filtered);
          
          setAppointmentBody({
            ...emptyBody,
            ...props.editData,
            customer: customerId,
            project: projectId,
            date: props.editData.date ? props.editData.date.split('T')[0] : ""
          });
        }
      } 
      else if (!props.editData) {
        if (!appointmentBody._id && appointmentBody.customer === "") {
          setAppointmentBody(emptyBody);
          setProjects([]);
        }
      }
    }
  }, [props.isOpen, props.editData, customers, appointmentBody._id]); 

  const handleClose = () => {
    setAppointmentBody(emptyBody);
    setProjects([]);
    props.closeModal();
  }

  const selectCustomer = (id) => {
    const customer = customers.find(c => c._id === id)
    const filteredProjects = (customer?.projects || []).filter(p => 
      p.projectType === "C" || p.type === "C"
    );

    setProjects(filteredProjects)
    setAppointmentBody(prev => ({ 
      ...prev, 
      customer: id, 
      project: "" 
    }))
  }

  const save = async () => {
    setLoading(true);
    try {
      if (appointmentBody._id) {
        await api.put(`pastDue/update/${appointmentBody._id}`, appointmentBody);
        props.showAlert("Apontamento atualizado com sucesso", "success");
      } else {
        await api.post("pastDue/create", appointmentBody);
        props.showAlert("Apontamento salvo com sucesso", "success");
      }
      
      if(props.updateList) props.updateList();
      handleClose();
    } catch (error) {
      console.error("Erro ao salvar:", error);
      props.showAlert("Erro ao salvar dados", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal className="modal-dialog-centered" size="lg" isOpen={props.isOpen}>
      <div className="modal-header">
        <h5 className="modal-title">
          {appointmentBody._id ? "Editar Apontamento" : "Novo Apontamento"} Horas Vencidas
        </h5>
        <button className="close" onClick={handleClose}><span>×</span></button>
      </div>
      <CardBody>
        <PastDueAppointmentForm 
          customers={customers} 
          projects={projects} 
          appointmentBody={appointmentBody}
          setAppointmentBody={(val) => setAppointmentBody(val)} 
          selectCustomer={selectCustomer}
          selectProject={(id) => setAppointmentBody(prev => ({ ...prev, project: id }))}
        />
      </CardBody>
      <div className="modal-footer">
        <Button color="secondary" onClick={handleClose}>Cancelar</Button>
        <Button color="success" onClick={save} disabled={loading}>
          {loading ? "Salvando..." : "Salvar"}
        </Button>
      </div>
    </Modal>
  )
}